/* eslint-disable max-len */
/* eslint-disable import/prefer-default-export */
export const EMAIL_VALIDATION_PATTERN = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/;

// Regex to match phone number with format 999-999-9999
export const PHONE_VALIDATION_PATTERN = /^\d{3}-\d{3}-\d{4}$/;

// REGEX to validate amount in dollars close to 2 decimal places.
export const CC_SETUP_AND_MONTHLY_FEE_PATTERN = /^\d+(\.\d{1,2})?$/;
